import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"

import Picture from "components/ui/picture"
import { getImgSrcSet } from "helpers/image"
import { cn } from "styles/utils"

const CollectionAd = ({ ad, index, newPageFocusRef }) => {
  const newPageStartIndex = useSelector(
    (state) => state.collection.newPageStartIndex
  )

  const Comp = ad.href ? Link : "div"

  if (ad.ad_type === "jpg" || ad.ad_type === "gif" || ad.ad_type === "video") {
    return (
      <li
        className={cn(
          "tablet:mb-30 mb-24 px-8",
          ad.ad_size === 4 && "col-span-4",
          ad.ad_size === 3 && "col-span-3",
          ad.ad_size === 2 && "col-span-2"
        )}
      >
        <Comp
          aria-label={ad.label || "ad"}
          data-lc="collection-ad"
          ref={index === newPageStartIndex ? newPageFocusRef : undefined}
          {...(ad.href && { to: ad.href })}
        >
          <div className="relative w-full">
            {ad.ad_type === "video" ? (
              <video
                className="lazyload h-full w-full object-cover"
                data-autoplay
                loop
                muted
                playsInline
                preload="none"
              >
                {ad.webm && <source src={ad.webm} type="video/webm" />}
                {ad.mp4 && <source src={ad.mp4} type="video/mp4" />}
              </video>
            ) : ad.dims ? (
              <Picture
                alt={ad.label || "ads"}
                height={ad.dims.desktop.height}
                srcSet={[
                  {
                    height: ad.dims.mobile.height,
                    media: "(max-width: 767px)",
                    sizes: ad.ad_size == 1 ? "50vw" : "100vw",
                    srcSet: getImgSrcSet(
                      `${sl.config.jewlr_imgsmbly_url}assets/${ad[ad.ad_type].mobile.img_path}`,
                      ad.dims.mobile.width
                    ),
                    width: ad.dims.mobile.width,
                  },
                  {
                    height: ad.dims.tablet.height,
                    media: "(min-width: 768px) and (max-width: 1023px)",
                    sizes: ad.ad_size == 1 ? "33vw" : "66vw",
                    srcSet: getImgSrcSet(
                      `${sl.config.jewlr_imgsmbly_url}assets/${ad[ad.ad_type].tablet.img_path}`,
                      ad.dims.tablet.width
                    ),
                    width: ad.dims.tablet.width,
                  },
                  {
                    height: ad.dims.desktop.height,
                    media: "(min-width: 1024px)",
                    sizes:
                      ad.ad_size == 1
                        ? "(max-width: 1439px) calc((100vw - 215px) / 3), (max-width: 1919px) calc((100vw - 215px) / 4), 376px"
                        : "(max-width: 1439px) calc((100vw - 215px) / 3 * 2), (max-width: 1919px) calc((100vw - 215px) / 2), 792px",
                    srcSet: getImgSrcSet(
                      `${sl.config.jewlr_imgsmbly_url}assets/${ad[ad.ad_type].desktop.img_path}`,
                      ad.dims.desktop.width
                    ),
                    width: ad.dims.desktop.width,
                  },
                ]}
                width={ad.dims.desktop.width}
              />
            ) : (
              <Picture
                alt={ad.label || "ads"}
                height={ad.use_new_ratio ? "450" : "380"}
                srcSet={[
                  {
                    height: ad.use_new_ratio ? "450" : "380",
                    media: "(max-width: 767px)",
                    srcSet: `
                  ${ad[ad.ad_type].mobile.x1} 1x,
                  ${ad[ad.ad_type].mobile.x2} 2x,
                `,
                    width: ad.ad_size === 1 ? "360" : "766",
                  },
                  {
                    height: "288",
                    media: "(min-width: 768px) and (max-width: 1023px)",
                    srcSet: `
                  ${ad[ad.ad_type].tablet.x1} 1x,
                  ${ad[ad.ad_type].tablet.x2} 2x,
                `,
                    width: ad.ad_size === 1 ? "232" : "464",
                  },
                  {
                    height: ad.use_new_ratio ? "320" : "280",
                    media: "(min-width: 1024px)",
                    srcSet: `
                  ${ad[ad.ad_type].desktop.x1} 1x,
                  ${ad[ad.ad_type].desktop.x2} 2x,
                `,
                    width: ad.ad_size === 1 ? "330" : "660",
                  },
                ]}
                width={ad.ad_size === 1 ? "360" : "766"}
              />
            )}
          </div>
        </Comp>
      </li>
    )
  }

  return null
}

CollectionAd.propTypes = {
  ad: PropTypes.object,
  index: PropTypes.number,
  newPageFocusRef: PropTypes.object,
}

export default CollectionAd
